import { Injectable } from '@angular/core'
import { IEmployee } from '../model/employee';
import { APIService } from '../services/api.service'
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable()
export class EmployeeService {
    employee: IEmployee;
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',

            // 'Content-Type': undefined,
            'Access-Control-Allow-Origin': ' *'
        })
    }
    constructor(private _http: HttpClient, private _apiServices: APIService) { }
    // Method for get employee list
    getDoctors(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isforAdmin": true,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/AdminDoctorList", body, this.httpOptions)
            .catch(this.handleError);

    }



    //method for approving doctor's license
    approveDoctorLicense(doctorId: any,licenseValue: boolean){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let body = JSON.stringify({"id": doctorId,"token": loginUser.token,"licenseValue": licenseValue});
        return this._http.post(environment.apiURL + "/api/approveDoctorLicense", body, this.httpOptions)
        .catch(this.handleError);
    }

    // service for uploading the profile picture odf doctor. -- current
    uploadDoctorProfilePicture(orderForm): Observable<any> {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/uploadEmployeeProfileImage", orderForm)
            .catch(this.handleError);
    }

    // Method for Save employee details
    saveEmployee(employee, files) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        let data = employee;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/createEmployee", body, this.httpOptions)
            .catch(this.handleError);
    }





    registerEmployee(employee) {
        //let emp: IEmployee;
        var files: Array<File>;
        files.push(employee.imagefile)
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        let data = employee;
        let body = JSON.stringify(data);
        let filesdata = JSON.stringify(files);
        return this._http.post(environment.apiURL + "/api/createEmployee", body, this.httpOptions)
            .map(files => filesdata)
            .subscribe(files => console.log('files', files))
        // .catch(this.handleError);
    }

    // Method for get Staff list

    getStaff(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('loginUser')
        console.log(loginUser)
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isforAdmin": true,
        }
        let body = JSON.stringify(data);

        return this._http.post(environment.apiURL + "/api/getStaff", body, this.httpOptions)
            .catch(this.handleError);

    }

    // Method for verify employee 
    verifyEmployee(employee) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('loginUser')
        console.log(loginUser)
        employee.isVerified = employee.isVerified == true ? false : true;
        let data = { "id": employee.id, "token": loginUser.token, "isverified": employee.isVerified }
        let body = JSON.stringify(data);
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');

        return this._http.post(environment.apiURL + "/api/verifyDoctor", body, this.httpOptions)
            .catch(this.handleError);
    }


    // method for save web user along with Welcome email and sms 

    saveWebUser(userdata) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        let data = userdata;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/saveWebUser", body, this.httpOptions)
            .catch(this.handleError);
    }

    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }

    // this method for use render page

    setEmpleeData(data) {
        this.employee = data;
    }

    getEmpleeData() {
        let temp = this.employee;
        return temp;
    }



    getEmployeedetails(employee) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = { "empid": employee.id, "token": loginUser.token }
        let body = JSON.stringify(data);
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/getEmployeeProfile", body, this.httpOptions)
            .catch(this.handleError);
    }

    updateEmployee(employee, files) {
        //let emp: IEmployee;      
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        let data = employee;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/updateEmployee", body, this.httpOptions)
            .catch(this.handleError);
    }

    getStaffdetails(employee) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = { "empid": employee.id, "token": loginUser.token }
        let body = JSON.stringify(data);
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/getStaffProfile", body, this.httpOptions)
            .catch(this.handleError);
    }

    // Method for verify employee

    deleteEmployee(employee) {

        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('loginUser')
        console.log(loginUser)
        employee.isactive = false;
        let data = { "id": employee.id, "token": loginUser.token, "isactive": employee.isactive }
        let body = JSON.stringify(data);
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');

        return this._http.post(environment.apiURL + "/api/deleteDoctor", body, this.httpOptions)
            .catch(this.handleError);
    }


    // This method is used for save fist available doctor 

    saveFirstAvailableDoctor(userdata) {

        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');

        //let data = userdata;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('loginUser')
        console.log(loginUser)
        userdata.isFirstAvailable = userdata.isFirstAvailable == true ? false : true;
        let data = { "id": userdata.id, "token": loginUser.token, "isactive": userdata.isFirstAvailable }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/addFirstAvailableDoctor", body, this.httpOptions)
            .catch(this.handleError);
    }

    getFirstAvailableDoctors(): Observable<any> {

        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isforAdmin": true,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getFirstAvailableDoctors", body, this.httpOptions)
            .catch(this.handleError);

    }

    savegroupaDoctor(userdata) {

        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = userdata;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('loginUser')
        console.log(loginUser)
        userdata.isFromGroupADoctor = userdata.isFromGroupADoctor == true ? false : true;
        let data = { "id": userdata.id, "token": loginUser.token, "isfromgroupa": userdata.isFromGroupADoctor }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/assignGroupADoctor", body, this.httpOptions)
            .catch(this.handleError);
    }


    updateEmployeeloginStatus(employee) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('loginUser')
        console.log(loginUser)
        employee.isactive = false;
        let data;
        if (employee.doctorAvailability) {
            data = { "userid": employee.id, "token": loginUser.token, "isavailableondemand": false, "isavailablebyphone": false, "isavailablebyvideo": false }
        }
        else { data = { "userid": employee.id, "token": loginUser.token, "isavailableondemand": true, "isavailablebyphone": true, "isavailablebyvideo": true } }

        let body = JSON.stringify(data);
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/changeAvailablityStatus", body, this.httpOptions)
            .catch(this.handleError);
    }

    getAllSubscriptionList(){
        console.log('getAllSubscriptionList');
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {"token" : loginUser.token};
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getAllSubscriptionDashboard", body, this.httpOptions)
        .catch(this.handleError);
    }

    saveSubscription(data){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        data.token = loginUser.token;
        console.log('data in service ', data);
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/saveSubscription", body, this.httpOptions)
        .catch(this.handleError);
    }

    insertSubscriptionDetails(data){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        data.token = loginUser.token;
        console.log('data in service ', data);
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/insertSubscriptionDetails", body, this.httpOptions)
        .catch(this.handleError);
    }

    activateSubscriptionPlan(id: any, status: any){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {id : id, token: '' , statusValue : status};
        data.token = loginUser.token;
        console.log('data in service ', data);
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/activateSubscription", body, this.httpOptions)
        .catch(this.handleError);
       
    }

    updateSubscriptionDetails(data){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        data.token = loginUser.token;
        console.log('data in service ', data);
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/updateSubscription", body, this.httpOptions)
        .catch(this.handleError);
    }
   

    deleteSubscription(id){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {"token": loginUser.token,"subscriptionId": id};
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/deleteSubscription", body, this.httpOptions)
        .catch(this.handleError);
    }

    getSubscriptionCount(){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {"token": loginUser.token};
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getAllSubscriptionCount", body, this.httpOptions)
        .catch(this.handleError);
    }

    //method for booking appointment from admin dashboard.
    bookPatientAppointment(aptData: any){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        aptData.token = loginUser.token;
        let data = aptData;
        console.log('data service ', data);
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/bookAppointmentByDashboard", body, this.httpOptions)
        .catch(this.handleError);
        
    }

    //method for getting appointments of a patient
    getPatientAppointments(userid: any){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {"token": loginUser.token, "userid": userid};
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getPatientAndDependentappointments", body, this.httpOptions)
        .catch(this.handleError);
        
    }
}


// WEBPACK FOOTER //
// ./src/app/services/employee.service.ts